import { EchoConversation } from "@bgea-js/form-templates";
import * as React from 'react';
export default {
  EchoConversation,
  React
};